// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ygCmZ9Bm0aUxBdfEe8tJ{position:absolute;top:4px;z-index:2147483648;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"arrowBtnPosition": "ygCmZ9Bm0aUxBdfEe8tJ"
};
export default ___CSS_LOADER_EXPORT___;
